module.exports = __webpack_public_path__ + "static/media/i19.88dbe3e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i19.svg
// module id = 193
// module chunks = 12